/**
 * Billing format mixin
 *
 * Provides common formatting functions for billing-related data
 */
export default {
  methods: {
    formatCurrency(amount, currency) {
      if (!amount) return 'N/A';
      // Convert amount to number, round it to remove decimals
      const roundedAmount = Math.round(Number(amount));
      // Add thousand separators
      const formattedAmount = roundedAmount.toLocaleString('en-US');
      return `${formattedAmount} ${currency.toUpperCase()}`;
    },
    formatDateRange(startDate, endDate) {
      if (!startDate || !endDate) return 'N/A';
      return `${this.formatDate(startDate)} - ${this.formatDate(endDate)}`;
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },
    capitalizeFirstLetter(string) {
      if (!string) return '';
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
};
